<!--
  page:餐饮监控表单页面
  author:余秋桐
  date:2025-07-08
  lastEdit:2025-07-08
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="originSearch">
        <a-row :gutter="24">
          <!-- 厂区 -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['fd.areacode']">
              <a-select
                v-model="areaCode"
                :options="selectDataAreaCodeList"
                :filterOption="filterOption"
                @change="selectArea"
              ></a-select>
            </a-form-item>
          </a-col>
          <!-- 餐厅地址 -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['commandCenter.title.restaurantAddress']">
              <a-select
                v-model="restaurantAddress"
                :options="restaurantOptions"
                :filterOption="filterOption"
                show-search
              ></a-select>
            </a-form-item>
          </a-col>
          <!-- 厂商 -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['fd_useridtype.A3']">
              <a-select
                v-model="firmAim"
                :options="firmOptions"
                :filterOption="filterOption"
                show-search
              ></a-select>
            </a-form-item>
          </a-col>
          <!-- 区域 -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['area']">
              <a-select
                v-model="areaAim"
                :options="areaOptions"
                :filterOption="filterOption"
                show-search
              ></a-select>
            </a-form-item>
          </a-col>
          <!-- 事件等级 -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['commandCenter.title.eventSeverity']">
              <a-select
                v-model="eventLevelLabel"
                :options="eventLevelOptions"
                :filterOption="filterOption"
              ></a-select>
            </a-form-item>
          </a-col>
          <!-- 检测类型 -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['commandCenter.title.testingType']">
              <a-select
                v-model="checkTypeLabel"
                :options="checkTypeOptions"
                :filterOption="filterOption"
              ></a-select>
            </a-form-item>
          </a-col>
          <!-- 事件 -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['commandCenter.title.event']">
              <a-input
                v-model="eventLabel"
                :placeholder="language['commandCenter.title.eventHolder1']"
                allowClear
              ></a-input>
            </a-form-item>
          </a-col>
          <!-- 数据来源 -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['epi.gas.data.sources']">
              <a-select
                v-model="dataSourcesLabel"
                :options="dataSourcesOptions"
                :filterOption="filterOption"
              ></a-select>
            </a-form-item>
          </a-col>
          <!-- 事件时间 -->
          <a-col :xl="6" :lg="9" :md="10" :sm="24">
            <a-form-item :label="language['commandCenter.title.eventDate']">
              <a-range-picker
                value-format="YYYY-MM-DD"
                v-model="eventDate"
                :placeholder="[
                  language['common.chooseStartDate'],
                  language['common.chooseEndDate'],
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 录入时间 -->
          <a-col :xl="6" :lg="9" :md="10" :sm="24">
            <a-form-item :label="language['commandCenter.title.inputDate']">
              <a-range-picker
                value-format="YYYY-MM-DD"
                v-model="enterDate"
                :placeholder="[
                  language['common.chooseStartDate'],
                  language['common.chooseEndDate'],
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" @click="originSearch" icon="search">
        {{ language["common.searchButton"] }}
      </a-button>
      <a-button type="primary" @click="searchReset" icon="reload">
        {{ language["common.resetButton"] }}
      </a-button>
      <a-button type="primary" icon="cloud-upload" @click="openImportModal">
        {{ language["commandCenter.title.bulkImport"] }}
      </a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ language["common.choosed"] }}
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >{{ language["common.item"] }}
        <a style="margin-left: 24px" @click="onClearSelected">
          {{ language["common.clear"] }}
        </a>
      </div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="sysdeviceid"
        class="j-table-force-nowrap"
        :scroll="{ x: 1800 }"
        :dataSource="dataSource"
        :pagination="ipagination"
        :columns="columns"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="action" slot-scope="text, record">
          <a @click="openDetailModal(record)">{{ language["ispforum.details"] }}</a>
        </template>
      </a-table>
    </div>

    <!-- 批量导入弹窗 -->
    <j-modal
      :visible="showImportModal"
      :title="language['commandCenter.title.bulkImport']"
      :width="1200"
      @ok="importHandleOk"
      :ok-disabled="!modalTableShow"
      @cancel="importHandleCancel"
      :okText="language['common.submitButton']"
      :cancelText="language['fd.Basic.FmDiningroomList.guanbi']"
      :confirm-loading="modalTableLoading"
    >
      <a-steps :current="importStep" size="small" :status="stepStatus">
        <a-step :title="language['labor.fileUpload']" />
        <a-step :title="language['commandCenter.title.dataValidation']" />
        <a-step :title="language['commandCenter.title.importSubmission']" />
      </a-steps>
      <div style="height: 20px" />
      <a-upload
        :multiple="false"
        :file-list="fileList"
        :remove="handleRemove"
        :before-upload="beforeUpload"
        @change="handleChange"
      >
        <span @click.stop="() => false">
          <span style="color: red">*</span>
          {{ language["labor.fileUpload"] }}：
        </span>
        <!-- :disabled="fileList.length > 0" -->
        <a-button icon="cloud-upload">
          {{ language["commandCenter.title.selectFile"] }}
        </a-button>
        <a-button
          type="primary"
          style="margin-left: 10px"
          :disabled="fileList.length === 0"
          :loading="upLoading"
          @click.stop="handleUpload"
        >
          {{
            upLoading
              ? language["commandCenter.title.uploading"]
              : language["common.uploadButton"]
          }}
        </a-button>
        <a style="margin-left: 10px" @click.stop="downloadTemplat">
          {{ language["commandCenter.title.downloadImportTemplate"] }}
        </a>
      </a-upload>
      <div class="tips-box">
        <div class="tips-title">
          {{ language["commandCenter.title.importInstructions"] }}
        </div>
        <div>1.{{ language["commandCenter.title.explain1"] }}：xlsx</div>
        <div>2.{{ language["commandCenter.title.explain4"] }}</div>
        <div>3.{{ language["commandCenter.title.explain2"] }}</div>
      </div>
      <!-- 上传报错提示 -->
      <template v-if="uploadFalseTextList.length > 0">
        <div
          class="tips-error-text"
          v-for="(item, index) in uploadFalseTextList"
          :key="index"
        >
          {{ item }}
        </div>
      </template>
      <template v-if="modalTableShow">
        <div style="height: 16px"></div>
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="sysdeviceid"
          class="j-table-force-nowrap"
          :scroll="{ x: 800, y: 500 }"
          :pagination="false"
          :dataSource="getUploadList"
          :columns="getUploadColumns"
          :loading="modalTableLoading"
        >
        </a-table>
      </template>
      <template v-if="submitShow">
        <div class="submit-box" v-if="submitStatus">
          <a-icon
            type="check-circle"
            theme="filled"
            style="color: green; font-size: 60px; margin-bottom: 10px"
          />
          <div>
            <span>导入成功，共导入</span>
            <span style="color: #3260c9; font-weight: bold">{{ submitResult }}</span>
            <span>条数据</span>
          </div>
        </div>
        <div class="submit-box" v-else>
          <a-icon
            type="close-circle"
            theme="filled"
            style="color: red; font-size: 60px; margin-bottom: 10px"
          />
          <div>
            {{ submitFalseText }}
          </div>
        </div>
      </template>
    </j-modal>

    <!-- 详情弹窗 -->
    <j-modal
      :visible="showDetailModal"
      :title="language['commandCenter.title.incidentDetail']"
      :width="800"
      @cancel="detailHandleCancel"
      :footer="null"
    >
      <div class="detail-box">
        <div class="detail-item" v-for="(item, index) in detailInfo" :key="index">
          <div class="detail-left-text">
            {{ item.leftText + "：" }}
          </div>
          <div class="detail-right-text">
            {{ item.rightText() }}
          </div>
        </div>
      </div>
    </j-modal>
  </a-card>
</template>

<script>
import { getAction, postAction, downFile, uploadAction } from "@/api/manageFood";
export default {
  data() {
    return {
      areaCode: "",
      selectDataAreaCodeList: [],
      restaurantAddress: "",
      restaurantOptions: [],
      firmAim: "",
      firmOptions: [],
      areaAim: "",
      areaOptions: [],
      eventLevelLabel: "",
      eventLevelOptions: [],
      checkTypeLabel: "",
      checkTypeOptions: [],
      dataSourcesLabel: "",
      dataSourcesOptions: [],
      eventLabel: "",
      eventDate: "",
      enterDate: "",
      selectedRowKeys: [],
      selectionRows: [],
      loading: false,
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total, range) => {
          return (
            range[0] +
            "-" +
            range[1] +
            this.$store.getters.language["common.total"] +
            total +
            this.$store.getters.language["common.strip"]
          );
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      showImportModal: false,
      importStep: 0, // 0 文件上传 / 1 数据确认 / 2 导入提交
      stepStatus: "process",
      fileList: [],
      upLoading: false,
      isUpload: false,
      uploadFalseTextList: [],
      getUploadList: [],
      getUploadColumns: [],
      modalTableShow: false,
      modalTableLoading: false,
      submitShow: false,
      submitStatus: false,
      submitResult: 0,
      showDetailModal: false,
      detailInfo: [],
      debounce: false,
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    columns() {
      if (this.language) {
        return [
          // 记录编号
          {
            title: this.language["commandCenter.title.recordNumber"],
            align: "center",
            width: 170,
            dataIndex: "recordno",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 厂区
          {
            title: this.language["fd.areacode"],
            align: "center",
            dataIndex: "areaname",
            width: 150,
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            customRender: (text, record) => {
              return text || "-";
            },
          },
          // 厂商
          {
            title: this.language["fd_useridtype.A3"],
            width: 150,
            align: "center",
            dataIndex: "firmname",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 餐厅地址
          {
            title: this.language["commandCenter.title.restaurantAddress"],
            width: 150,
            align: "center",
            dataIndex: "drname",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 区域
          {
            title: this.language["area"],
            align: "center",
            width: 150,
            dataIndex: "position",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 检测类型
          {
            title: this.language["commandCenter.title.testingType"],
            width: 150,
            align: "center",
            dataIndex: "detectioncategory",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 事件
          {
            title: this.language["commandCenter.title.event"],
            width: 150,
            align: "center",
            dataIndex: "activename",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 责任人
          {
            title: this.language["esg.duty.person"],
            width: 150,
            align: "center",
            dataIndex: "username",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 等级
          {
            title: this.language["commandCenter.title.level"],
            width: 150,
            align: "center",
            dataIndex: "eventlevel",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 违规点
          {
            title: this.language["commandCenter.title.violationPoints"],
            width: 150,
            align: "center",
            dataIndex: "violationpoint",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 违规次数
          {
            title: this.language["commandCenter.title.numberViolations"],
            width: 150,
            align: "center",
            dataIndex: "violationcount",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 事件时间
          {
            title: this.language["commandCenter.title.eventDate"],
            width: 160,
            align: "center",
            dataIndex: "eventtime",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 评定状态
          {
            title: this.language["commandCenter.title.evaluationStatus"],
            width: 160,
            align: "center",
            dataIndex: "assessstatus",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 追踪结果
          {
            title: this.language["commandCenter.title.trackingResults"],
            width: 160,
            align: "center",
            dataIndex: "trackingresult",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 惩处建议
          {
            title: this.language["commandCenter.title.penaltyProposal"],
            width: 160,
            align: "center",
            dataIndex: "disciplinaryaction",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 视频是否存档
          {
            title: this.language["commandCenter.title.vidioArchived"],
            width: 160,
            align: "center",
            dataIndex: "videoarchived",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text ? "是" : "否";
            },
          },
          // 数据来源
          {
            title: this.language["epi.gas.data.sources"],
            width: 160,
            align: "center",
            dataIndex: "datasources",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 登记人
          {
            title: this.language["commandCenter.title.registrant"],
            width: 160,
            align: "center",
            dataIndex: "registrant",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 备注
          {
            title: this.language["emp.empCmsEntrance.remark"],
            width: 160,
            align: "center",
            dataIndex: "remark",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 录入时间
          {
            title: this.language["commandCenter.title.inputDate"],
            width: 160,
            align: "center",
            dataIndex: "createdate",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 操作
          {
            title: this.language["common.action"],
            dataIndex: "action",
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: "action" },
          },
        ];
      }
    },
  },
  watch: {
    fileList(newVal, oldValue) {
      this.getUploadList = [];
      this.getUploadColumns = [];
      this.uploadFalseTextList = [];
      this.importStep = 0;
      this.stepStatus = "process";
      this.modalTableShow = false;
      this.submitShow = false;
    },
  },
  mounted() {
    // 厂区选项卡
    this.selectDataAreaCodeList = [
      {
        label: this.language["ipsys.all"],
        value: "",
      },
    ];
    getAction("/FMSYS/getBindingData", { dicCode: "areacode", auth: true }).then(
      (res) => {
        if (res.success) {
          this.selectDataAreaCodeList.push(...res.result);
        }
      }
    );

    this.initSearchOptions();
    this.searchReset();
  },
  methods: {
    originSearch() {
      this.ipagination.current = 1;
      this.searchQuery();
    },
    openDetailModal(info) {
      console.log("info:", info);
      this.detailInfo = [];
      let list = [];
      list = this.columns.slice(0, -1);
      this.detailInfo = list.map((element) => {
        return {
          leftText: element.title,
          rightText: () => {
            if (element.dataIndex === "videoarchived") {
              return info[element.dataIndex] ? "是" : "否";
            } else if (info[element.dataIndex]) {
              return info[element.dataIndex];
            } else {
              return "-";
            }
          },
        };
      });
      this.showDetailModal = true;
    },
    detailHandleCancel() {
      this.showDetailModal = false;
    },
    // 下载模板
    downloadTemplat() {
      if (this.debounce) {
        return this.$message.warn(this.language["commandCenter.title.tips2"]);
      }
      this.debounce = true;
      setTimeout(() => {
        this.debounce = false;
      }, 1500);

      let params = {
        templateType: "CATERING",
      };
      console.log("importType:", this.importType);
      const fileName = this.language["fd.menu.commandCenter.restaurantControl"] + ".xlsx";
      downFile("FM_DEVICE/GetImportTemplate", params).then((data) => {
        console.log("导入模板：", data);
        if (!data || data.size === 0) {
          Vue.prototype["$message"].warning(
            that.$store.getters.language["common.fileDowloadError"]
          );
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(new Blob([data]), fileName);
        } else {
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    // 删除文件时调用
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
      this.initModalData();
    },
    // 文件上传之前调用，返回 false 可取消上传
    beforeUpload(file) {
      // this.fileList = [...this.fileList, file];
      return false; // 返回 false 不自动上传，手动控制上传过程
    },
    // 文件状态改变时调用，比如上传中、上传完成和上传失败时
    handleChange(info) {
      console.log("*** info ***", info);
      // let fileList = [...info.fileList];
      let fileList = [info.fileList[info.fileList.length - 1]];
      // 按照服务器响应信息筛选成功上传的文件
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
    },
    // 手动触发上传
    handleUpload() {
      if (this.debounce) {
        return this.$message.warn(this.language["commandCenter.title.tips2"]);
      }
      this.debounce = true;
      setTimeout(() => {
        this.debounce = false;
      }, 1500);

      this.upLoading = true;
      this.modalTableShow = false;
      const formData = new FormData();
      formData.append("file", this.fileList[0].originFileObj);
      // return
      uploadAction("FM_MONITOR_CENTER/UploadExcel", formData)
        .then((res) => {
          this.upLoading = false;
          this.submitShow = false;
          if (res.code === 200) {
            if (res.result) {
              this.importStep = 1;
              this.getUploadList = res.result;
              let tableList = this.columns.slice(1, -2);
              tableList.splice(11, 1);
              tableList.splice(14, 1);
              this.getUploadColumns = tableList;
              this.modalTableShow = true;
            } else {
              let falseTextList = res.message.split("\n");
              this.uploadFalseTextList = falseTextList;
            }
          }
          console.log("上传res:", res);
        })
        .catch((err) => {
          this.upLoading = false;
          this.submitShow = false;
          this.uploadFalseTextList = [this.language["commandCenter.title.tips3"]];
        });
    },
    importHandleOk() {
      if (this.debounce) {
        return this.$message.warn(this.language["commandCenter.title.tips2"]);
      }
      this.debounce = true;
      setTimeout(() => {
        this.debounce = false;
      }, 1500);

      this.importStep = 2;
      this.modalTableLoading = true;
      console.log("isModalTable:", this.getUploadList);
      postAction("FM_MONITOR_CENTER/ImportData", this.getUploadList)
        .then((res) => {
          this.modalTableLoading = false;
          console.log("上传提交：", res);
          this.modalTableShow = false;
          this.submitShow = true;
          if (res.success) {
            this.stepStatus = "finish";
            this.submitStatus = true;
            this.submitResult = res.result;
            this.originSearch();
          } else {
            this.submitStatus = false;
            this.submitFalseText = res.message;
          }
        })
        .catch((err) => {
          this.importStep = 2;
          this.submitShow = true;
          this.submitStatus = false;
          this.submitFalseText = "服务超时";
        });
    },
    initModalData() {
      this.getUploadList = [];
      this.getUploadColumns = [];
      this.uploadFalseTextList = [];
      this.fileList = [];
      this.importStep = 0;
      this.stepStatus = "process";
      this.modalTableShow = false;
      this.submitShow = false;
    },
    importHandleCancel() {
      this.showImportModal = false;
      this.initModalData();
    },
    openImportModal() {
      this.showImportModal = true;
    },
    selectArea() {
      this.restaurantAddress = "";
      this.firmAim = "";
      this.initSearchOptions();
    },
    handleTableChange(res) {
      this.ipagination = res;
      this.searchQuery();
    },
    /* 列表根据code 查找文字 */
    filterListText(list, text) {
      for (let key of list) {
        if (key.value === text) {
          return key.label;
        }
      }
      return "-";
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    searchReset() {
      this.areaCode = "";
      this.restaurantAddress = "";
      this.firmAim = "";
      this.areaAim = "";
      this.eventLevelLabel = "";
      this.checkTypeLabel = "";
      this.eventLabel = "";
      this.dataSourcesLabel = "";
      this.eventDate = "";
      this.enterDate = "";
      this.ipagination.current = 1;

      this.initSearchOptions();
      this.searchQuery();
    },
    // 自定义搜索逻辑（按 label 匹配）
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .includes(input.toLowerCase());
    },
    initSearchOptions() {
      // 数据来源选项卡
      this.dataSourcesOptions = [
        {
          label: this.language["ipsys.all"],
          value: "",
        },
        {
          label: "AI",
          value: "AI",
        },
        {
          label: this.language["commandCenter.title.artificial"],
          value: "人工",
        },
      ];

      this.getAreaPositionOptions();
      this.getCheckTypeOptions();
      this.getEventLevelOptions();
      this.getFirmOptions();
      this.getRestaurantOptions();
    },
    // 获取区域(点位)选项
    getAreaPositionOptions() {
      getAction("/UNIS_ALARM_ORIGIN_DATA_POSITION/all", {}).then((res) => {
        if (res.success) {
          console.log("区域(点位)选项：", res);
          let list = res.result.map((element) => {
            return {
              label: element.position,
              value: element.position,
            };
          });
          this.areaOptions = [
            {
              label: this.language["ipsys.all"],
              value: "",
            },
            ...list,
          ];
        }
      });
    },
    // 获取检测类型选项
    getCheckTypeOptions() {
      getAction("/UNIS_ALARM_ORIGIN_DATA_DETECTION_CATEGORY/all", {}).then((res) => {
        if (res.success) {
          console.log("检测类型选项：", res);
          let list = res.result.map((element) => {
            return {
              label: element.detectioncategory,
              value: element.detectioncategory,
            };
          });
          this.checkTypeOptions = [
            {
              label: this.language["ipsys.all"],
              value: "",
            },
            ...list,
          ];
        }
      });
    },
    // 获取事件等级选项
    getEventLevelOptions() {
      getAction("/UNIS_ALARM_ORIGIN_DATA_EVENT_LEVEL/all", {}).then((res) => {
        if (res.success) {
          console.log("事件等级选项：", res);
          let list = res.result.map((element) => {
            return {
              label: element.eventlevel,
              value: element.eventlevel,
            };
          });
          this.eventLevelOptions = [
            {
              label: this.language["ipsys.all"],
              value: "",
            },
            ...list,
          ];
        }
      });
    },
    // 获取厂商选项
    getFirmOptions() {
      getAction("/FM_FIRM/all", { areacode: this.areaCode }).then((res) => {
        if (res.success) {
          console.log("厂商选项：", res);
          let list = res.result.map((element) => {
            return {
              label: element.firmname,
              value: element.firmcode,
            };
          });
          this.firmOptions = [
            {
              label: this.language["ipsys.all"],
              value: "",
            },
            ...list,
          ];
        }
      });
    },
    // 获取餐厅选项
    getRestaurantOptions() {
      getAction("/FM_DININGROOM/all", { areacode: this.areaCode }).then((res) => {
        if (res.success) {
          console.log("餐厅选项：", res);
          let list = res.result.map((element) => {
            return {
              label: element.drname,
              value: element.drcode,
            };
          });
          this.restaurantOptions = [
            {
              label: this.language["ipsys.all"],
              value: "",
            },
            ...list,
          ];
        }
      });
    },
    searchQuery() {
      console.log("*** 厂商 ***", this.firmAim);
      this.loading = true;
      let params = {
        areacode: this.areaCode ? this.areaCode : "", // 厂区
        DRCODE: this.restaurantAddress ? this.restaurantAddress : "", // 餐厅
        SYSFIRMID: this.firmAim ? this.firmAim : "", // 厂商
        position: this.areaAim ? this.areaAim : "", // 区域
        eventlevel: this.eventLevelLabel ? this.eventLevelLabel : "", // 事件等级
        detectioncategory: this.checkTypeLabel ? this.checkTypeLabel : "", // 检测类型
        activename: this.eventLabel ? this.eventLabel : "", // 事件名称
        datasources: this.dataSourcesLabel ? this.dataSourcesLabel : "", // 数据来源
        eventtime_begin: this.eventDate ? this.eventDate[0] : "", // 事件开始事件
        eventtime_end: this.eventDate ? this.eventDate[1] : "", // 事件结束事件
        createdate_begin: this.enterDate ? this.enterDate[0] : "", // 录入开始时间
        createdate_end: this.enterDate ? this.enterDate[1] : "", // 录入结束时间
        PageNo: this.ipagination.current,
        PageSize: this.ipagination.pageSize,
      };
      for (const [key, value] of Object.entries(params)) {
        // 当value的值为 null || "" || undefined 时去除该键值对
        if (value === null || value === "" || value === undefined) {
          //筛选条件可根据实际情况自行调整
          Reflect.deleteProperty(params, key);
        }
      }
      const that = this;
      getAction("FM_MONITOR_CENTER/getPage", params).then((res) => {
        console.log("*** res ***", res);
        if (res.code === 200 && res.result.records) {
          that.dataSource = res.result.records || []; // 安全访问
          that.ipagination.total = res.result.total;
        }
        that.loading = false;
      });
    },
  },
};
</script>

<style scoped>
::v-deep .ant-steps-item-process .ant-steps-item-icon {
  background: #3260c9;
}

.detail-right-text {
  flex: 1;
  min-width: 170px;
  word-break: break-all;
  /* border: 1px solid; */
}

.detail-left-text {
  width: 30%;
  min-width: 80px;
  word-break: break-all;
  text-align: right;
  font-weight: bold;
  /* border: 1px solid; */
}

.detail-item {
  width: 46%;
  min-width: 250px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  /* border: 1px solid; */
}

.detail-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

@keyframes submitShow {
  0% {
    opacity: 0;
    top: 30px;
  }

  100% {
    opacity: 1;
    top: 0;
  }
}

.submit-box {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-top: 20px;
  position: relative;
  animation: 0.3s submitShow;
}

.tips-error-text {
  width: 100%;
  line-height: 30px;
  text-align: center;
  color: red;
}

.tips-box {
  margin-top: 20px;
}

.tips-title {
  font-weight: bold;
}
</style>
